import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://claimbeast.com";
const DEFAULT_IMAGE = `${SITE_URL}/assets/claim-beast-logo.png`;

// react-helmet-async 3 on React 19 hoists tags natively and does NOT reconcile
// the build-time prerendered tags (marked data-rh="true"), so strip those once
// the client tags are in place. Non-JS crawlers never run this and keep them.
const removePrerenderedTags = () => {
  document.head
    .querySelectorAll('[data-rh="true"]')
    .forEach((el) => el.remove());
};

/**
 * SEO component that sets per-page meta tags + JSON-LD schema.
 */
const SEO = ({
  title,
  description,
  path = "/",
  keywords,
  image = DEFAULT_IMAGE,
  schemas = [],
  noindex = false,
}) => {
  const url = `${SITE_URL}${path}`;
  useEffect(removePrerenderedTags, []);
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <meta
        name="robots"
        content={
          noindex
            ? "noindex, nofollow"
            : "index, follow, max-image-preview:large, max-snippet:-1"
        }
      />
      <meta name="author" content="Claim Beast Public Adjusters" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={title} />
      <meta property="og:site_name" content="Claim Beast Public Adjusters" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD schemas */}
      {schemas.map((schema, i) => (
        <script type="application/ld+json" key={i}>
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
